import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

const KEY = "gme_cookie_pref";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (pref) => { localStorage.setItem(KEY, pref); setShow(false); };

  return (
    <AnimatePresence>
      {show && (
        <motion.div data-testid="cookie-consent"
          initial={{ y: 60, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 60, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[125]">
          <div className="rounded-2xl bg-[#0B1020]/95 backdrop-blur-xl ring-1 ring-[#C9A24B]/30 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.9)] p-5">
            <p className="text-sm text-cream/75 leading-relaxed">
              We use cookies to improve your experience and understand how this site is used. See our{" "}
              <Link to="/privacy-policy" className="text-[#E7CC86] hover:underline">Privacy</Link> &{" "}
              <Link to="/cookie-policy" className="text-[#E7CC86] hover:underline">Cookie Policy</Link>.
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-2.5">
              <button data-testid="cookie-accept" onClick={() => decide("all")} className="btn-gold px-4 py-2 rounded-full text-sm font-semibold">Accept All</button>
              <button data-testid="cookie-essential" onClick={() => decide("essential")} className="btn-ghost-gold px-4 py-2 rounded-full text-sm">Essential Only</button>
              <Link to="/cookie-policy" data-testid="cookie-preferences" className="text-sm text-cream/55 hover:text-[#E7CC86] transition-colors ml-auto">Preferences</Link>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
